import styled from "styled-components"
import React, { useEffect } from "react"
import { DropdownButton } from "react-bootstrap"

const colorArray: string[] = [
    "#F7A600", "#FFC400", "#FFE380", "#DA555D", "#F67C7C", "#FFB1B1", "#A65FBF", "#C573D9", "#DC9EF2",
    "#7E5FBF", "#8D73D9", "#AC9EF2", "#0057D7", "#417AEA", "#75A2F7", "#027ED9", "#1DA0FE", "#56B8FF",
    "#00A688", "#18C191", "#66DEC1", "#00A64C", "#2BC560", "#66DE80", "#8393AE", "#C0CBDD", "#F1F3F8",
]

const ColorPickerDropdown = styled(DropdownButton)`
    & > .btn, & > .btn:active, & > .btn:focus, & > .btn:active:focus {
        width: 80px;
        height: 40px;
        border-radius: 0;
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        padding: 0;
        margin-bottom: 8px;
        background: ${(props) => props.theme.inputBackground} !important;

        &::after {
            content: "";
            display: block;
            border-top: 4px solid ${(props) => props.theme.inputColor};
            border-right: 4px solid transparent;
            border-bottom: 0;
            border-left: 4px solid transparent;
            position: absolute;
            left: 62px;
            top: 50%;
            transform: translateY(-125%);
        }
    }

    & > .dropdown-menu {
        max-width: 410px;
        box-sizing: border-box;
        padding: 6px;
        border-radius: 0;
        border: 1px solid ${(props) => props.theme.selectDropdownBackground};
        background: ${(props) => props.theme.selectDropdownBackground};
    }
`
const TitleColor = styled.div<{
    background: string
}>`
    width: 60px;
    height: 100%;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    background: ${(props) => props.background};
`
const Color = styled.div<{
    background: string
    selected: boolean
}>`
    width: 32px;
    height: 32px;
    border-radius: 4px;
    margin: 6px;
    float: left;
    box-shadow: ${(props) => (
        props.selected ? `0 0 0 2px ${props.theme.selectDropdownBackground}, 0 0 0 4px ${props.theme.colorPickerSelectedColor}` : "none"
    )};
    background: ${(props) => props.background};
`

export interface ColorPickerProps {
    selectedColor: string
    onChange: (color: string) => void
}
export const ColorPicker = ({
    selectedColor,
    onChange,
}: ColorPickerProps) => {
    useEffect(() => {
        if (!selectedColor) {
            const randomColor = colorArray[Math.floor(Math.random() * colorArray.length)]
            onChange(randomColor)
        }
    }, [])

    return (
        <ColorPickerDropdown title={selectedColor ? <TitleColor background={selectedColor} /> : ""}>
            {
                colorArray.map((color) => (
                    <Color
                        key={color}
                        background={color}
                        selected={color === selectedColor}
                        onClick={() => onChange(color)}
                    />
                ))
            }
        </ColorPickerDropdown>
    )
}
